import BadgeEdit from '@/screens/BadgeEdit';

export default function PrivateBadgeBadgeIdIndexRoute() {
  return <BadgeEdit />;
}
